import {
  CREATECHANNELPARTNERPAYOUT,
  GETCHANNELPARTNERPAYOUT,
  UPDATECHANNELPARTNERPAYOUT,
  DELETECHANNELPARTNERPAYOUT,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATECHANNELPARTNERPAYOUT:
      return {
        ...state,
        channelpartnerpayoutSaveStatus: action.payload.success,
      };
    case GETCHANNELPARTNERPAYOUT:
      return {
        ...state,
        channelpartnerpayoutList: action.payload.data,
      };
    case UPDATECHANNELPARTNERPAYOUT:
      return {
        ...state,
        channelpartnerpayoutUpdateStatus: action.payload.success,
      };

    case DELETECHANNELPARTNERPAYOUT:
      return {
        ...state,
        channelpartnerpayoutDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
